module.exports = __webpack_public_path__ + "fonts/LatoLatin-Regular.f42ffe0.woff2";